import React from 'react';

const SearchSection = ({ onSearchResults }) => {
  return (
    <section className="search-luxhom">
      <div className="container">
        <div className="search-container-luxhom">
          <div 
            className="search-header-luxhom"
          >
            <div className="search-badge-luxhom">OUR LOCATIONS</div>
            <h2>We Provide Properties in These Cities</h2>
            <p>
              Discover luxury properties across India's most prestigious locations. 
              Our expert team serves clients in major metropolitan areas and premium destinations.
            </p>
          </div>

          <div 
            className="locations-display-luxhom"
          >
            <div className="locations-grid-luxhom">
              <div className="location-item-luxhom">
                <i className="fas fa-map-marker-alt"></i>
                <span>Karnataka</span>
              </div>
              <div className="location-item-luxhom">
                <i className="fas fa-map-marker-alt"></i>
                <span>Goa</span>
              </div>
              <div className="location-item-luxhom">
                <i className="fas fa-map-marker-alt"></i>
                <span>Andhra Pradesh</span>
              </div>
              <div className="location-item-luxhom">
                <i className="fas fa-map-marker-alt"></i>
                <span>Tamil Nadu</span>
              </div>
              <div className="location-item-luxhom">
                <i className="fas fa-map-marker-alt"></i>
                <span>Pune</span>
              </div>
              <div className="location-item-luxhom">
                <i className="fas fa-map-marker-alt"></i>
                <span>Mumbai</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SearchSection;